import React from "react";
import "./curriculumTable.scss";
import "../../../styles/fontSizes.scss";
import Text from "componets/atoms/text/text";
import palette from "styles/palette.scss";
const CurriculumTable = ({ data, type }) => {
  /*ESTRUCTURA DE data:
    const data = {
        
        rows: [
        {title: "Académicas básicase introducción a la vida universitaria",
        COb: 16, COp: 0, Cto: 16
        },
        {title: "Matemáticas",
        COb: 9, COp: 10, Cto: 19
        },
        {title: "Programación y ciencias de datos",
        COb: 7, COp: 7, CTo: 14
        },
    ]
    }*/
  return (
    <>
      <table className="curriculum-t__table">
        <thead>
          <tr>
            <th>Agrupación</th>
            <th>Créditos obligatorios</th>
            <th>Créditos optativos</th>
            <th>Total créditos exigidos</th>
          </tr>
        </thead>
        <tbody>
          {data && data.rows
            ? data.rows.map((row, index) => (
                <tr key={index}>
                  <td>
                    <Text type="h" textSize={2} color={palette.white}>
                      {row.title}
                    </Text>
                  </td>
                  <td>
                    <Text type="p" textSize={2} color={palette.black}>
                      {row.COb}
                    </Text>
                  </td>
                  <td>
                    <Text type="p" textSize={2} color={palette.black}>
                      {row.COp}
                    </Text>
                  </td>
                  <td>
                    <Text type="p" textSize={2} color={palette.black}>
                      {row.CTo}
                    </Text>
                  </td>
                </tr>
              ))
            : "No hay datos por mostrar"}
        </tbody>
      </table>
    </>
  );
};

export default CurriculumTable;
